export default __webpack_public_path__ + "static/media/hero@2x.2c9237d6.png";